export const careers_positions_data = [
	{
		post_id: 1,
		post_title: 'Web3 Developer',
		post_short_description: 'We are seeking a full-time Software QA Analyst to join our team in the Web3 hiring landscape, where we prioritize exceptional quality, overall functionality, and usability.',
		post_title_2: 'Experience – 3 to 5 years',
	},
	{
		post_id: 2,
		post_title: 'Solidity Developer',
		post_short_description: 'We are in search of a full-time Software QA Analyst to join our team in the realm of Solidity developer hiring, where our focus is on ensuring outstanding quality, comprehensive functionality, and user-friendliness.',
		post_title_2: 'Experience – 3 to 5 years',
	},
	{
		post_id: 3,
		post_title: 'Blockchain Engineer',
		post_short_description: 'We are actively seeking a full-time Software QA Analyst to join our team in the realm of Blockchain Engineer hiring. Our primary goal is to ensure exceptional quality, comprehensive functionality, and seamless usability across our blockchain-based projects.',
		post_title_2: 'Experience – 3 to 5 years',
	},
	{
		post_id: 4,
		post_title: 'React Developer',
		post_short_description: 'We are currently seeking a full-time Software QA Analyst to join our team in the domain of React developer hiring. Our goal is to guarantee exceptional quality, comprehensive functionality, and user-friendliness across our projects.',
		post_title_2: 'Experience – 3 to 5 years',
	},
	{
		post_id: 5,
		post_title: 'Full Stack Engineer',
		post_short_description: 'We are actively seeking a full-time Software QA Analyst to join our team in the realm of full stack developer hiring. Our primary objective is to ensure exceptional quality, comprehensive functionality, and seamless user experience across our projects.',
		post_title_2: 'Experience – 3 to 5 years',
	},
	{
		post_id: 6,
		post_title: 'UI / UX Designer',
		post_short_description: 'We are currently seeking a full-time Software QA Analyst to join our team in the field of UI/UX developer hiring. Our aim is to guarantee outstanding quality, overall functionality, and exceptional user experience across our projects.',
		post_title_2: 'Experience – 3 to 5 years',
	},
	// {
	// 	post_title: 'Content Writer',
	// 	post_short_description: 'We are looking for a full-time Software QA Analyst to be part of our team to ensure the top-notch quality, overall functionality and usability.',
	// 	post_title_2: 'Experience – 1 to 2 years',
	// 	post_id: 3,
	// },
	// {
	// 	post_title: 'Growth Hacker',
	// 	post_short_description: 'We are looking for a full-time Software QA Analyst to be part of our team to ensure the top-notch quality, overall functionality and usability.',
	// 	post_title_2: 'Experience – 3 to 5 years',
	// 	post_id: 5,
	// },
	// {
	// 	post_title: 'Media Marketer',
	// 	post_short_description: 'We are looking for a full-time Software QA Analyst to be part of our team to ensure the top-notch quality, overall functionality and usability.',
	// 	post_title_2: 'Experience – 3 to 5 years',
	// 	post_id: 6,
	// },
];
